import { api } from '../services/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const fallbackSlides = [
    {
        id: 1,
        isActive: true,
        imageUrl: '/images/slides/1.jpeg',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
    },
    {
        id: 2,
        isActive: true,
        imageUrl: '/images/slides/2.jpeg',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
    },
    {
        id: 3,
        isActive: true,
        imageUrl: '/images/slides/3.jpeg',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
    },
    {
        id: 4,
        isActive: true,
        imageUrl: '/images/slides/4.jpeg',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
    }
];

export const fetchSliderItems = createAsyncThunk(
    'slider/fetchSliderItems',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/slider');
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.message || 'Failed to fetch slider items');
        }
    }
);

const sliderSlice = createSlice({
    name: 'slider',
    initialState: {
        items: fallbackSlides,
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderItems.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchSliderItems.fulfilled, (state, action) => {
                state.items = action.payload;
                state.status = 'succeeded';
            })
            .addCase(fetchSliderItems.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || action.error.message;
            });
    },
});

export const selectSliderItems = (state) => state.slider.items;
export const selectSliderStatus = (state) => state.slider.status;
export const selectSliderError = (state) => state.slider.error;

export default sliderSlice.reducer;
